import { EventObject } from "../../../util/event/EventObject";
/**
 * CommonGameEvent.ts
 */
export class CommonGameEvent {
}
CommonGameEvent.STAKE_UPDATED = new EventObject("CommonGameEvent.STAKE_UPDATED");
CommonGameEvent.STAKE_SELECTOR_OPEN = new EventObject("CommonGameEvent.STAKE_SELECTOR_OPEN");
CommonGameEvent.STAKE_SELECTOR_CLOSE = new EventObject("CommonGameEvent.STAKE_SELECTOR_CLOSE");
CommonGameEvent.OPTIONS_MENU_OPEN = new EventObject("CommonGamEvent.OPTIONS_MENU_OPEN");
CommonGameEvent.OPTIONS_MENU_CLOSE = new EventObject("CommonGamEvent.OPTIONS_MENU_CLOSE");
CommonGameEvent.HELP_OPEN = new EventObject("CommonGameEvent.HELP_OPEN");
CommonGameEvent.HELP_CLOSE = new EventObject("CommonGameEvent.HELP_CLOSE");
CommonGameEvent.HELP_DIALOG_OPEN = new EventObject("CommonGameEvent.HELP_DIALOG_OPEN");
CommonGameEvent.HELP_DIALOG_CLOSE = new EventObject("CommonGameEvent.HELP_DIALOG_CLOSE");
CommonGameEvent.HELP_DIALOG_PAGE = new EventObject("CommonGameEvent.HELP_DIALOG_PAGE");
CommonGameEvent.PAY_TABLE_OPEN = new EventObject("CommonGameEvent.PAY_TABLE_OPEN");
CommonGameEvent.PAY_TABLE_CLOSE = new EventObject("CommonGameEvent.PAY_TABLE_CLOSE");
CommonGameEvent.BALANCE_UPDATED = new EventObject("CommonGameEvent.BALANCE_UPDATED");
CommonGameEvent.RECOVERY = new EventObject("CommonGameEvent.RECOVERY");
CommonGameEvent.WAGER_RESPONSE = new EventObject("CommonGameEvent.WAGER_RESPONSE");
CommonGameEvent.RESPONSIBLE_GAMING_OPEN = new EventObject("CommonGameEvent.RESPONSIBLE_GAMING_OPEN");
CommonGameEvent.RESPONSIBLE_GAMING_CLOSE = new EventObject("CommonGameEvent.RESPONSIBLE_GAMING_CLOSE");
CommonGameEvent.DGH_OPEN = new EventObject("CommonGameEvent.DGH_OPEN");
CommonGameEvent.RESPONSIBLE_GAMING_SAVE_SETTINGS = new EventObject("CommonGameEvent.RESPONSIBLE_GAMING_SAVE_SETTINGS");
CommonGameEvent.RESPONSIBLE_GAMING_CANCEL_SETTINGS = new EventObject("CommonGameEvent.RESPONSIBLE_GAMING_CANCEL_SETTINGS");
CommonGameEvent.RESPONSIBLE_GAMING_SET_TRIGGER = new EventObject("CommonGameEvent.RESPONSIBLE_GAMING_SET_TRIGGER");
CommonGameEvent.RESPONSIBLE_GAMING_INSTRUCTIONS_OPEN = new EventObject("CommonGameEvent.RESPONSIBLE_GAMING_INSTRUCTIONS_OPEN");
CommonGameEvent.RESPONSIBLE_GAMING_INSTRUCTIONS_CLOSE = new EventObject("CommonGameEvent.RESPONSIBLE_GAMING_INSTRUCTIONS_CLOSE");
CommonGameEvent.CURRENT_GAME_RESULT = new EventObject("CommonGameEvent.CURRENT_GAME_RESULT");
// new
CommonGameEvent.INITIALISE = new EventObject("CommonGameEvent.INITIALISE");
CommonGameEvent.START_GAME = new EventObject("CommonGameEvent.START_GAME");
CommonGameEvent.PURCHASE_ENTRY = new EventObject("CommonGameEvent.PURCHASE_ENTRY");
CommonGameEvent.SPIN = new EventObject("CommonGameEvent.SPIN");
CommonGameEvent.FREE_SPIN = new EventObject("CommonGameEvent.FREE_SPIN");
CommonGameEvent.PURCHASE_SPIN = new EventObject("CommonGameEvent.PURCHASE_SPIN");
CommonGameEvent.STANDARD_SPIN_RECOVERY = new EventObject("CommonGameEvent.STANDARD_SPIN_RECOVERY");
CommonGameEvent.FREE_SPIN_RECOVERY = new EventObject("CommonGameEvent.FREE_SPIN_RECOVERY");
CommonGameEvent.PURCHASE_SPIN_RECOVERY = new EventObject("CommonGameEvent.PURCHASE_SPIN_RECOVERY");
CommonGameEvent.START_GAME_REQUEST = new EventObject("CommonGameEvent.START_GAME_REQUEST");
CommonGameEvent.SPIN_REQUEST = new EventObject("CommonGameEvent.SPIN_REQUEST");
CommonGameEvent.PURCHASE_SPIN_REQUEST = new EventObject("CommonGameEvent.PURCHASE_SPIN_REQUEST");
CommonGameEvent.COLLECT_REQUEST = new EventObject("CommonGameEvent.COLLECT_REQUEST");
CommonGameEvent.NEXT_GAME_REQUEST = new EventObject("CommonGameEvent.NEXT_GAME_REQUEST");
CommonGameEvent.COMPLETE = new EventObject("CommonGameEvent.COMPLETE");
CommonGameEvent.UPDATE_CLIENT = new EventObject("CommonGameEvent.UPDATE_CLIENT");
CommonGameEvent.BACKGROUND_SOUND_ON = new EventObject("CommonGameEvent.BACKGROUND_SOUND_ON");
CommonGameEvent.BACKGROUND_SOUND_OFF = new EventObject("CommonGameEvent.BACKGROUND_SOUND_OFF");
CommonGameEvent.SFX_OFF = new EventObject("CommonGameEvent.SFX_OFF");
CommonGameEvent.SFX_ON = new EventObject("CommonGameEvent.SFX_ON");
CommonGameEvent.GAME_OVER_CONFIRM = new EventObject("CommonGameEvent.GAME_OVER_CONFIRM");
CommonGameEvent.GAME_OVER_CONFIRMED = new EventObject("CommonGameEvent.GAME_OVER_CONFIRMED");
CommonGameEvent.MAX_PURCHASE_STAKE_EXCEEDED = new EventObject("CommonGameEvent.MAX_PURCHASE_STAKE_EXCEEDED");
CommonGameEvent.MAX_TOTAL_STAKE_EXCEEDED = new EventObject("CommonGameEvent.MAX_TOTAL_STAKE_EXCEEDED");
CommonGameEvent.SOUND_MUTED = new EventObject("CommonGameEvent.SOUND_MUTED");
CommonGameEvent.CLOSE_CURRENT_DIALOG = new EventObject("CommonGameEvent.CLOSE_CURRENT_DIALOG");
CommonGameEvent.FREE_ROUNDS_NEW_GAME_REQUEST = new EventObject("CommonGameEvent.FREE_ROUNDS_NEW_GAME_REQUEST");
CommonGameEvent.FREE_ROUNDS_IN = new EventObject("CommonGameEvent.FREE_ROUNDS_IN");
CommonGameEvent.FREE_ROUNDS_OUT = new EventObject("CommonGameEvent.FREE_ROUNDS_OUT");
CommonGameEvent.FREE_ROUNDS_EXTRA_SPINS = new EventObject("CommonGameEvent.FREE_ROUNDS_EXTRA_SPINS");
CommonGameEvent.OPEN_ACCESSIBLE_HELP = new EventObject("CommonGameEvent.OPEN_ACCESSIBLE_HELP");
CommonGameEvent.GAME_REPLAY = new EventObject("CommonGameEvent.GAME_REPLAY");
CommonGameEvent.REPLAY_START = new EventObject("CommonGameEvent.REPLAY_START");
CommonGameEvent.REPLAY_PURCHASE_ENTRY = new EventObject("CommonGameEvent.REPLAY_PURCHASE_ENTRY");
CommonGameEvent.REPLAY_STOP = new EventObject("CommonGameEvent.REPLAY_STOP");
CommonGameEvent.REPLAY_FINISHED = new EventObject("CommonGameEvent.REPLAY_FINISHED");
//Spine events:
CommonGameEvent.PLAY_SPINE_SOUND = new EventObject("CommonGameEvent.PLAY_SPINE_SOUND");
CommonGameEvent.BONUS = new EventObject("CommonGameEvent.BONUS");
CommonGameEvent.BONUS_WON = new EventObject("CommonGameEvent.BONUS_WON");
//Analytics
CommonGameEvent.BI_ERROR = new EventObject("CommonGameEvent.BI_ERROR");
CommonGameEvent.BI_KPI = new EventObject("CommonGameEvent.BI_KPI");
CommonGameEvent.BI_DEBUG = new EventObject("CommonGameEvent.BI_DEBUG");
//# sourceMappingURL=CommonGameEvent.js.map